import CreatableSelect from 'react-select/creatable';
import createSelect from './createSelect';
export default createSelect(CreatableSelect);